import { methodSteps } from "@/mocks/archive";

export default function MethodSection() {
  return (
    <section id="method" className="w-full px-4 md:px-8 py-14 md:py-20 bg-accent-50">
      <div className="max-w-3xl mb-8 md:mb-12">
        <span className="text-xs tracking-[0.22em] text-accent-700">METHODOLOGY</span>
        <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          挖旧料，也讲究规矩
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
          热闹的结论到处都是，难得的是可复核的过程。下面四步，是我们处理每一份档案时都不会跳过的环节。
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {methodSteps.map((step) => (
          <div
            key={step.step}
            className="relative flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-accent-200"
          >
            <span className="font-heading text-3xl md:text-4xl font-bold text-accent-300 leading-none">
              {step.step}
            </span>
            <span className="mt-4 w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 text-xl">
              <i className={step.icon}></i>
            </span>
            <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
              {step.title}
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}